import {defineComponent} from "vue"
import moment from "@/utils/moment"

export default defineComponent({
  methods: {
    formatPhone(phone: string): string {
      if (!phone) return ''
      // format as (123) 456-7890
      const cleaned = phone.replace(/\D/g, '')
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (!match) return phone
      return `(${match[1]}) ${match[2]}-${match[3]}`
    },
    // use moment.js to format date
    formatDate(date: any, formatString: string = 'MM/DD/YYYY'): string {
      if (!date) return ''
      return moment(date).format(formatString)
    },
    formatMoney(amount: number): string {
      if (!amount && amount !== 0) return ''
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount)
    }
  }
})
